export function addMaxWidthToImageLocation(imageLocation: string | undefined, width: number): string {
  if (!imageLocation) {
    return '';
  }

  return `${imageLocation}?maxWidth=${width}`;
}
